import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

function UserCustomDashboard() {
  const { userId } = useAuth();
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!userId) return;

    fetch(`https://www.denisbitter.de/stage01/api/get_user_individual_dashboard.php?user_id=${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCourses(data.data);
        } else {
          setError(data.message || "Fehler beim Laden der Daten.");
        }
      })
      .catch(() => {
        setError("Server nicht erreichbar. Bitte später erneut versuchen.");
      });
  }, [userId]);

  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">🧩 Meine individuellen Kurse</h1>

      {error && (
        <div className="bg-red-100 text-red-600 p-4 mb-4 rounded text-sm">
          {error}
        </div>
      )}

      {courses.length === 0 ? (
        <p className="text-gray-600">Keine Kurse gefunden.</p>
      ) : (
        <div className="space-y-6">
          {courses.map((course) => (
            <div key={course.course_id} className="bg-white border shadow p-4 rounded-lg">
              <h2 className="text-lg font-semibold text-gray-800">
                {course.title || "Individueller Kurs"}
              </h2>
              <p className="text-gray-500 text-sm mb-2">
                Erstellt am: {course.created_at}
              </p>

              <div className="space-y-2 text-sm font-mono">
                {course.modules.map((mod, index) => (
                  <div key={index} className="border rounded p-2 bg-gray-50">
                    <strong>{mod.project_title}</strong>
                    <p>Start: {mod.start_date || "n. a."}</p>
                    <p>Dauer: {mod.duration} Tage</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UserCustomDashboard;
